<hr class="hr" />
<div class="d-flex flex-wrap">
  <img ngSrc="./assets/footer_logo.svg" width="200" height="75" priority alt="Logo" class="logo"/>

  @if (isIreg | async) {
    <img ngSrc="./assets/rid_logo.jpg" width="200" height="86" alt="Logo" class="logo"/>
    <div class="clause flex-grow-1" >
      <b><span i18n="@@ireg.clause">Dofinansowano ze środków Ministra Nauki przyznanych w ramach Programu „Regionalna inicjatywa doskonałości” na realizację projektu „Uniwersytet Ekonomiczny w Poznaniu dla Gospodarki 5.0: Inicjatywa regionalna – efekty globalne (IREG)”</span></b>
    </div>
    <img ngSrc="./assets/mnisw_logo.png" width="180" height="65" alt="Logo" class="logo"/>
  }
</div>
